<template>
    <div>
        <!-- Header -->
        <div class="py-3 mb-3 border-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 d-flex">
                        <h5 class="m-0 p-0 align-self-center">
                            <i class="fas fa-chart-bar mr-1"></i> Relatório de Envio / Não Envio
                        </h5>
                    </div>
                    <div class="col-12 col-sm-6 text-left text-sm-right d-flex justify-content-end">
                        <!-- Period -->
                        <change-date :start-date="from" :end-date="to" locale="pt-BR" @changeDate="changeDate" class="ml-sm-auto flex-grow-1 mr-auto mr-sm-3 mt-3 mt-sm-0"></change-date>
                    </div>
                </div>
            </div>
        </div>

        <!-- Content -->
        <div class="container">

            <!-- Filters -->
            <div class="row mb-2">
                <div class="col-sm-6">
                    <!-- Field -->
                    <b-form-group label="Turmas">
                        <multiselect
                            v-model="group"
                            :options="groups"
                            :loading="loadingGroup"
                            track-by="id"
                            label="name"
                            @select="selectGroup"
                            @remove="removeGroup"
                            placeholder="Filtrar por Turma ..."
                            tag-placeholder="Filtrar Turma"
                            selectLabel="Selecionar"
                            deselectLabel="Desmarcar"
                            selectedLabel="Selecionado">

                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há turmas disponíveis para exibir :(
                            </span>
                        </multiselect>
                    </b-form-group>
                </div>
                <div class="col-sm-6">
                    <!-- Field -->
                    <b-form-group label="Aluno">
                        <multiselect
                            v-model="student"
                            :options="students"
                            :loading="loadingStudent"
                            track-by="id"
                            label="name"
                            @select="selectStudent"
                            @remove="removeStudent"
                            @search-change="searchStudent"
                            tag-placeholder="Filtrar Aluno"
                            placeholder="Filtrar por Aluno"
                            selectLabel="Selecionar"
                            deselectLabel="Desmarcar"
                            selectedLabel="Selecionado">

                                <span slot="noResult">
                                    Ops! Nenhum resultado encontrado na pesquisa :(
                                </span>

                                <span slot="noOptions">
                                    Não há alunos disponíveis para exibir :(
                                </span>

                        </multiselect>
                    </b-form-group>
                </div>
            </div>

            <!-- Table Overview -->
            <b-overlay :show="loading" rounded="sm">
                <div class="row mb-4">
                    <div class="col-sm-6">
                        <div class="card">
                            <div class="card-header">
                                Enviaram
                            </div>
                            <div class="card-body">
                                <table-custom :table="send" />
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="card">
                            <div class="card-header">
                                Não Enviaram
                            </div>
                            <div class="card-body">
                                <table-custom :table="no_send" />
                            </div>
                        </div>
                    </div>
                </div>

            </b-overlay>
        </div>
    </div>
</template>

<script>
import ChangeDate from "./ChangeDate";
import TableCustom from "./Table";

export default {
    components: {
        ChangeDate,
        TableCustom
    },
    props: ['from', 'to', 'groups'],
    data() {
        return {
            loading: false,
            loadingGroup: false,
            loadingStudent: false,
            send: [],
            no_send: [],
            filter: {
                start_date: this.from,
                end_date: this.to,
                group_id: null,
                student_id: null,
            },
            group: null,
            student: null,
            students: [],
        }
    },
    created() {

        // Load
        this.load()
        this.searchStudent(null)
    },
    watch: {
        'filter.group_id'() {
            this.searchStudent(null)
        }
    },
    methods: {

        load() {
            this.loading = true;
            axios.get('/teacher/reports-students/sendings/data', {
                params: {
                    from: this.$moment(this.filter.start_date).format('YYYY-MM-DD'),
                    to: this.$moment(this.filter.end_date).format('YYYY-MM-DD'),
                    group_id: this.filter.group_id,
                    student_id: this.filter.student_id,
                }
            })
                .then(async (result) => {
                    const response = result.data.data;

                    this.send = response.send;
                    this.no_send = response.no_send;
                })
                .finally(() => this.loading = false)
        },

        async selectGroup(value) {
            this.filter.group_id = await value.id;

            // Load
            await this.load()
        },

        async removeGroup() {
            this.filter.group_id = await null;

            // Load
            await this.load()
        },

        async changeDate(dateFilters) {
            this.filter.start_date = await dateFilters.startDate;
            this.filter.end_date = await dateFilters.endDate;

            // Load
            await this.load()
        },
        searchStudent(text, searchViaQuery = false) {
            this.loadingStudent = true;
            axios.get('/teacher/students/search', {
                params: {
                    group_id: this.filter.group_id,
                    name: text
                }
            })
                .then(async (result) => {
                    this.students = await result.data.data.students;

                    // Check Params via Query
                    if (searchViaQuery) {
                        if (this.query.studentId) {
                            this.students.forEach((student) => {
                                if (student.id == this.query.studentId) {
                                    this.student = student;
                                    this.filter.student_id = this.query.studentId;
                                    // Load
                                    this.load()
                                }
                            })
                        }
                    }
                })
                .finally(() => this.loadingStudent = false)
        },
        async selectStudent(value) {
            this.filter.student_id = await value.id;

            // Load
            await this.load()
        },

        async removeStudent() {
            this.filter.student_id = await null

            // Load
            await this.load()
        },
    }
}
</script>

<style scoped>

</style>
